<header class="col-12 header-page">
    <h1 class="header__page__content__title">
        Análise de Pagamento
    </h1>
</header>

<ng-template #showLoading>
    <spinner [show]="true"></spinner>
</ng-template>

<main>
    
    <form class="col-12 main__page__content__form" [formGroup]="formData" (ngSubmit)="consultar()">
        <section class="col-12 content-form row px-0">
            <div class="col-xl-4 col-lg-6 col-md-6 col-sm-12 mb-2 px-1">
                <label class="content__form__title__label">Selecione quem deseja consultar</label>
                <ng-select bindLabel="Selecione o Ano desejado" bindValue="id" placeholder="Selecione o ano"
                    [clearable]="false" [items]="years" formControlName="ano" (change)="anoChanged()" (focus)="onFocus($event)" [searchable]="false">
                </ng-select>
            </div>
            <div class="col-xl-4 col-lg-6 col-md-6 col-sm-12 mb-2 px-1" *ngIf="formData.value.ano" [@fadeInOut]>
                <label class="content__form__title__label">Selecione o Primeiro Mês Desejado</label>
                <ng-select bindLabel="description" bindValue="number" placeholder="Selecione o mês inicial"
                    [clearable]="false" [items]="initialMonths" formControlName="mesInicial" (change)="mesChanged()" (focus)="onFocus($event)" [searchable]="false">
                </ng-select>
            </div>
            <div class="col-xl-4 col-lg-6 col-md-6 col-sm-12 mb-2 px-1"
                *ngIf="formData.value.ano && formData.value.mesInicial" [@fadeInOut]>
                <label class="content__form__title__label">Selecione o Ultimo Mês Desejado</label>
                <ng-select bindLabel="description" bindValue="number" placeholder="Selecione o mês final"
                    [clearable]="false" [items]="finalMonths" [disabled]="true" formControlName="mesFinal" (focus)="onFocus($event)" [searchable]="false">
                </ng-select>
            </div>
        </section>
        <button class="btn button-primary col-xl-2 col-lg-3 col-md-4 col-sm-12 mr-xl-1 mr-lg-1" type="submit"
            [disabled]="this.loading || formData.invalid"
            *ngIf="formData.value.ano && formData.value.mesInicial && formData.value.mesFinal">
            <div class="d-flex" *ngIf="loading; else showSpan" [@fadeIn]>
                <span>Consultando</span>
            </div>
            <ng-template #showSpan>
                <span [@fadeIn]>Consultar</span>
            </ng-template>
        </button>
    </form>

    <aviso>
        Caso queira consultar pagamentos anteriores à 01/01/2003, entrar em contato com o setor da Previdência da
        Fundação Copel através do Email: <a href="mailto:previdencia@fcopel.org,br">{{'previdencia@fcopel.org.br'}}</a>
    </aviso>

    <ng-template #naoPossuiAnalise>
        <p class="ng-template-text" *ngIf="pesquisado">Não possui analise de pagamento para o período selecionado!</p>
    </ng-template>
    
    <section *ngIf="!loading; else showLoading">
        <section class="mt-1" *ngIf="paymentAnalyzeItems && paymentAnalyzeItems.length > 0 else naoPossuiAnalise">
            <section class="content__header__table">
                <div class="col-10">Nº guia</div>
                <div class="col-2">Ações</div>
            </section>
            <section class="content__main__table">
                <div class="table__card" *ngFor="let item of paymentAnalyzeItems">
                    <div class="col-10">{{item.reference}}</div>
                    <div class="col-2">
                        <a #modal class="fa-icon mr-2" (click)="imprimir(item)" data-toggle="tooltip" data-placement="top" title="Imprimir">
                            <fa-icon [icon]="faPrint"></fa-icon>
                        </a>
                        <a #modal class="fa-icon" (click)="visualizarDetalhes(item)" data-toggle="tooltip" data-placement="top" title="Visualizar">
                            <fa-icon [icon]="faEye"></fa-icon>
                        </a>
                    </div>
                </div>
            </section>
        </section>
    </section>

</main>
